import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsx } from 'react/jsx-runtime';

var l=c=>jsx("svg",b(a({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 448 512",fill:"currentColor"},c),{children:jsx("path",{d:"M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"})})),n=l;

export { n as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-OGMUABZK.mjs.map